// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import AutoplayAnimation from './AutoplayAnimation';
import CircledPauseIcon from '../../../assets/images/circled-pause-icon.svg';
import CircledPlayIcon from '../../../assets/images/circled-play-icon.svg';
import PauseIcon from '../../../assets/images/pause-icon.svg';
import PlayIcon from '../../../assets/images/play-icon.svg';
import PipIcon from '../../../assets/images/pip.svg';
import FullScreenIcon from '../../../assets/images/full-screen.svg';
import RewindIcon from '../../../assets/images/rewind.svg'
import FastForwardIcon from '../../../assets/images/fast-forward.svg'
import SeekBar from './SeekBar';
import VolumeBar from './VolumeBar';
import Subtitle from './Subtitle';
import Resolution from './Resolution';
import LoadingAnimation from './LoadingAnimation';

export const S = {
  Wrapper: styled.div`
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    /* visibility: hidden; */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
  `,
  PauseIcon: styled.img.attrs({ src: CircledPauseIcon, alt: 'big-pause-icon', draggable: false })`
    animation-delay: 0.5s;
    animation-name: fade;
    animation-duration: 0.3s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;

    @keyframes fade {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }
  `,
  PlayIcon: styled.img.attrs({ src: CircledPlayIcon, alt: 'big-play-icon', draggable: false })`
    animation-delay: 0.5s;
    animation-name: fade;
    animation-duration: 0.3s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;

    @keyframes fade {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }
  `,
  MiddleControls: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    position: relative;
  `,
  SubtitleText: styled.div`
    position: absolute;
    bottom: 24px;
    padding: 0 5px;
    font: 18px Noto Sans TC;
    background: #313131;
  `,
  BottomWrapper: styled.div.attrs({ draggable: false })`
    display: flex;
    flex-direction: column;
    padding: 0 24px 21px 24px;
  `,
  ControlWrapper: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    padding: 0px 6px;
    position: relative;
  `,
  LeftWrapper: styled.div`
    display: flex;
    align-items: center;
    & > img {
      margin-left: 19px;
    }
  `,
  RightWrapper: styled.div`
    display: flex;
    & > img, & > div{
      margin-left: 16px;
    }
  `,
  Time: styled.div`
    font: 20px Noto Sans TC;
  `,
  MiniIcon: styled.img.attrs<{playing: boolean}>((props) => ({
    src: props.playing ? PauseIcon : PlayIcon,
    alt: 'mini-icon',
    draggable: false
  }))<{playing: boolean}>`
    width: 25px;
    height: 25px;
    cursor: pointer;
  `,
  Rewind: styled.img.attrs({ src: RewindIcon })`
    height: 32px;
    width: 32px;
    cursor: pointer;
  `,
  FastForward: styled.img.attrs({ src: FastForwardIcon })`
    height: 32px;
    width: 32px;
    cursor: pointer;
  `,
  Pip: styled.img.attrs({ src: PipIcon })`
    height: 32px;
    width: 32px;
    cursor: pointer;
  `,
  FullScreen: styled.img.attrs({ src: FullScreenIcon })`
    height: 32px;
    width: 32px;
    cursor: pointer;
  `,
  Resolution: styled(Resolution)``,
  VolumeBar: styled(VolumeBar)``,
  Subtitle: styled(Subtitle)``,
  SeekWrapper: styled.div`
    height: 20px;
    display: flex;
    align-items: center;
  `,
  SeekBar: styled(SeekBar)`
    flex-grow: 1;
  `,
  LoadingIcon: styled.img``,
  AutoplayCancelText: styled.div`
    font: 24px Noto Sans TC;
    color: #FFF;
    text-decoration: underline;
    position: absolute;
    bottom: 24px;
    cursor: pointer;
  `,
  AutoplayAnimation: styled(AutoplayAnimation)`
    cursor: pointer;
  `,
  LoadingAnimation: styled(LoadingAnimation)``
};
